import { getWindow } from './globalWrappers';

export function get(): DeploymentConfig {
  return getWindow().DEPLOYMENT_CONFIG;
}

export function getOrganizationColors(): OrganizationColors {
  return get().organization.colors;
}

export function isNewToBank(): boolean {
  return get().anonymousBorrowerSupport === 'New To Bank';
}

export function isDelayedAccountCreation(): boolean {
  return get().anonymousBorrowerSupport === 'Delayed Account Creation';
}
